export default __webpack_public_path__ + "static/logo-39715fa4b70a1fcfb23482dab95ae1d0.png";